import script from "./DeveloperFeedbackCard.vue?vue&type=script&setup=true&lang=js"
export * from "./DeveloperFeedbackCard.vue?vue&type=script&setup=true&lang=js"

import "./DeveloperFeedbackCard.vue?vue&type=style&index=0&id=64d22ab2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-64d22ab2"]])

export default __exports__